import { TAX_INVOICE, TAX_RECEIPT } from "constants/clearingSaleAttributes";

function dataTourSlug(text) {
  return text.toLowerCase().replace(/\s+/g, "-");
}

function buildPerInvoiceeItems({
  invoiceeBusinesses,
  businessId,
  reportType,
  actionPrefix,
  buildOnClick,
}) {
  return invoiceeBusinesses.filter(Boolean).map(invoiceeBusiness => ({
    title: invoiceeBusiness.name,
    dataTour: `${actionPrefix}-${dataTourSlug(reportType)}-${invoiceeBusiness.id}`,
    onClick: buildOnClick(
      invoiceeBusiness,
      invoiceeBusiness.id !== businessId,
    ),
  }));
}

export function buildSplitViewActions({
  businessId,
  userRoleSlug,
  invoiceeBusinesses,
  invoiceUrl,
  receiptUrl,
}) {
  const buildOnClick = reportUrl => (invoiceeBusiness, consolidated) => () =>
    window.open(reportUrl(invoiceeBusiness.id, userRoleSlug, consolidated));

  return [
    {
      title: `View ${TAX_INVOICE}`,
      subNavItems: [
        {
          title: "Consolidated",
          dataTour: `view-${dataTourSlug(TAX_INVOICE)}-consolidated`,
          onClick: () => window.open(invoiceUrl(businessId, userRoleSlug)),
        },
        ...buildPerInvoiceeItems({
          invoiceeBusinesses,
          businessId,
          reportType: TAX_INVOICE,
          actionPrefix: "view",
          buildOnClick: buildOnClick(invoiceUrl),
        }),
      ],
    },
    {
      title: `View ${TAX_RECEIPT}`,
      subNavItems: [
        {
          title: "Consolidated",
          dataTour: `view-${dataTourSlug(TAX_RECEIPT)}-consolidated`,
          onClick: () => window.open(receiptUrl(businessId, userRoleSlug)),
        },
        ...buildPerInvoiceeItems({
          invoiceeBusinesses,
          businessId,
          reportType: TAX_RECEIPT,
          actionPrefix: "view",
          buildOnClick: buildOnClick(receiptUrl),
        }),
      ],
    },
  ];
}

export function buildSplitEmailActions({
  businessId,
  invoiceeBusinesses,
  invoiceUrl,
  receiptUrl,
  emailReport,
}) {
  const buildOnClick =
    (reportUrl, reportName) => (invoiceeBusiness, consolidated) => () =>
      emailReport(
        reportUrl(invoiceeBusiness.id, undefined, consolidated),
        reportName,
        invoiceeBusiness.id,
      );

  return [
    {
      title: `Email ${TAX_INVOICE}`,
      subNavItems: buildPerInvoiceeItems({
        invoiceeBusinesses,
        businessId,
        reportType: TAX_INVOICE,
        actionPrefix: "email",
        buildOnClick: buildOnClick(invoiceUrl, TAX_INVOICE),
      }),
    },
    {
      title: `Email ${TAX_RECEIPT}`,
      subNavItems: buildPerInvoiceeItems({
        invoiceeBusinesses,
        businessId,
        reportType: TAX_RECEIPT,
        actionPrefix: "email",
        buildOnClick: buildOnClick(receiptUrl, TAX_RECEIPT),
      }),
    },
  ];
}
